import type { ReactNode } from "react";
import { PanelTitle } from "@themes/pollinator/ui/PanelTitle";
import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  onStart: () => void;
  programName: string;
  /** Button text (default: "Get Started") */
  buttonText?: string;
  /** Whether the button is in a loading state */
  isLoading?: boolean;
  /** Optional secondary button rendered alongside the primary button */
  secondaryButton?: ReactNode;
  /** Optional description override */
  description?: string;
  /** Optional error message displayed above the button */
  errorMessage?: string | null;
};

export function InvitationIntro({
  onStart,
  programName,
  buttonText = "Get Started",
  isLoading = false,
  secondaryButton,
  description,
  errorMessage,
}: Props) {
  const defaultDescription = `Please confirm a few details to make sure ${programName} is a good fit for you.`;

  const primaryButton = (
    <Button
      variant="primary"
      theme="dark"
      className={secondaryButton ? "w-full md:w-fit min-w-24" : "w-full mb-14 md:size-max md:mb-0"}
      onClick={onStart}
      isLoading={isLoading}
      disabled={isLoading}
      data-testid="onboarding-intro-start"
    >
      {buttonText}
    </Button>
  );

  return (
    <PanelTitle
      title={`${programName} Onboarding`}
      description={description ?? defaultDescription}
      className="flex-1"
      isInverted
    >
      {errorMessage && (
        <Type variant="body2" className="text-error mb-4">
          {errorMessage}
        </Type>
      )}
      {secondaryButton ? (
        <div className="flex gap-3">
          {primaryButton}
          {secondaryButton}
        </div>
      ) : (
        primaryButton
      )}
    </PanelTitle>
  );
}

export default InvitationIntro;


